import React from "react";
import { Button } from "react-bootstrap";
import './White_Btn.css'

const White_Btn = ({ btnText, onClick, className = "" }) => {
    return (
        <section className="White_Btn_holder">
            <Button 
                className={`White_Btn ${className}`} 
                onClick={onClick}
            >
                {btnText}
            </Button>
        </section>
    )
}

export default White_Btn;
